import React, { useState, useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Container,
  FormGroup,
  FormText,
  Form,
  Input,
  Label,
  Row,
  Col,
} from "reactstrap";
import faqModel from "models/faq.model";
import { helper } from "lib/helper";
import Loader from "components/loader/Loader";
import City from ".";
import cityModel from "models/city.model";

const EditCity = () => {
  const [addsLoadig, setAddsLoadig] = useState(false);
  const [dataList, setDataList] = useState(null);
  const navigate = useNavigate();
  const parmas = useParams();
  const id = parmas?.id

  const handleSubmitEditCity = (event) => {
    setAddsLoadig(true);
    event.preventDefault();
    const form = new FormData(event.target);
    form.append("state", dataList && dataList.state);

    // You can adjust the header configuration according to your API requirements
    cityModel
      .updateCity(id,form)
      .then((response) => {
        helper.sweetalert.toast("Your City Edit.", "success");
        navigate("/admin/city");
        setAddsLoadig(false);
        // Display success message to the user
      })
      .catch((error) => {
        setAddsLoadig(false);
        // console.log(error);
      });
  };

  const getListDataByidCity = () => {
    cityModel
      .detailCity(parmas?.id)
      .then((response) => {
        setDataList(response.data);
      })
      .catch((error) => {
        // console.log(error);
      });
  };
  useEffect(() => {
    if (parmas.id != "") {
      getListDataByidCity();
    }
  }, []);

  return (
    <>
      <Container className="pt-7">
        <Row>
          <div className="col">
            <Card className="shadow">
              <CardHeader className="border-0 d-flex justify-content-between ">
                <h3 className="mb-0">Edit City</h3>
              </CardHeader>

              <CardBody>
                <div>
                  <Form onSubmit={handleSubmitEditCity}>
                    <Row>
                      <Col md={12}>
                        <FormGroup>
                          <Label for="exampleEmail">City Name</Label>
                          <Input
                            style={{
                              border: "1px solid lightgrey",
                              padding: "6px 10px",
                              borderRadius: "6px",
                            }}
                            id="name"
                            name="name"
                            placeholder="Enter City Name"
                            defaultValue={dataList && dataList.name}
                          />
                        </FormGroup>
                      </Col>

                    </Row>

                   

                    {/* <Row>
                <Col md={6}>
                  <FormGroup>
                    <Label for="exampleEmail">Added Date</Label>
                    <Input id="contact" name="contact" type="number" />
                  </FormGroup>
                </Col>

                <Col md={6}>
                  <FormGroup>
                    <Label for="exampleEmail">Status</Label>
                    <Input id="status" name="status" type="select">
                      <option value="">Activate</option>
                      <option value="option1">Deactivate</option>
                      <option value="option2">Pending</option>
                    </Input>
                  </FormGroup>
                </Col>
              </Row> */}

                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <Button color="secondary" to="/admin/city" tag={Link}>
                        Cancel
                      </Button>

                      {addsLoadig ? (
                        <Loader color={"blue"} />
                      ) : (
                        <Button
                        
                          type="submit"
                          style={{ float: "right", marginLeft: "5%",backgroundColor:"#080278",color:"white",border:"none" }}
                        >
                          Save
                        </Button>
                      )}
                    </div>
                  </Form>
                </div>
              </CardBody>
            </Card>
          </div>
        </Row>
      </Container>
    </>
  );
};




export default EditCity